import React, { FC, MutableRefObject } from 'react';
import { FullscreenPreviewModal } from 'src/common/FullscreenPreviewModal';
import { IconButton } from 'src/common/icon-button';
import { CloseStrongIcon } from 'src/monet/icons';
import { functionNoop } from 'src/utils/function/noop';

export interface WizardModalProps {
  openRef: MutableRefObject<() => void>;
  closeRef: MutableRefObject<() => void>;
  onClose?: () => void;
  onOpen?: () => void;
  hideCloseButton?: boolean;
}

export const WizardModal: FC<WizardModalProps> = ({
  openRef,
  closeRef,
  onOpen,
  onClose = functionNoop,
  children,
  hideCloseButton,
}) => (
  <FullscreenPreviewModal
    openRef={openRef}
    onClose={onClose}
    //@ts-ignore
    closeRef={closeRef}
    onOpen={onOpen}
    dialogClassName='bg-bedrock-white z-40'
    renderClose={(closeFn) => (
      <>
        {!hideCloseButton && (
          <div className='absolute top-6 left-4'>
            <IconButton onClick={closeFn}>
              <CloseStrongIcon className='w-5 h-5 text-bedrock-black' />
            </IconButton>
          </div>
        )}
      </>
    )}
  >
    {children}
  </FullscreenPreviewModal>
);
